import { Controller } from "stimulus"
export default class extends Controller {
  static targets = ["seatVisibility", "resToggle",
                    "waitlistToggle", "selfCheckInToggle", "programChoice"]

  connect() {
    this.toggleReservationsRequired()
  }

  // Stimulus actions

  toggleReservationsRequired() {
    if (this.reservationsRequiredIsChecked()) {
      this.showSeatInputField()
      if (this.chosenProgramCanHaveWaitlists()) {
        this.showWaitlistEnabledCheckbox()
      } else {
        this.hideWaitlistEnabledCheckbox()
        this.deselectWaitlistEnabled()
      }
      if (this.chosenProgramCanHaveSelfCheckIn()) {
        this.showSelfCheckIn()
      } else {
        this.hideSelfCheckIn()
        this.deselectSelfCheckIn()
      }
    } else {
      this.hideSeatInputField()
      this.hideWaitlistEnabledCheckbox()
      this.deselectWaitlistEnabled()
      this.hideSelfCheckIn()
      this.deselectSelfCheckIn()
    }
  }

  updateProgramChoice() {
    if (this.reservationsRequiredIsChecked()) {
      if (this.chosenProgramCanHaveWaitlists()) {
        this.showWaitlistEnabledCheckbox()
      } else {
        this.hideWaitlistEnabledCheckbox()
        this.deselectWaitlistEnabled()
      }
      if (this.chosenProgramCanHaveSelfCheckIn()) {
        this.showSelfCheckIn()
      } else {
        this.hideSelfCheckIn()
        this.deselectSelfCheckIn()
      }
    }
  }

  // Helper methods

  hideSeatInputField() {
    this.seatVisibilityTarget.classList.add("d-none")
  }

  showSeatInputField() {
    this.seatVisibilityTarget.classList.remove("d-none")
  }

  hideWaitlistEnabledCheckbox() {
    this.waitlistToggleTarget.classList.add("d-none")
  }

  showWaitlistEnabledCheckbox() {
    this.setWaitlistTooltip()
    this.waitlistToggleTarget.classList.remove("d-none")
  }

  // The tooltip lives on a <span> around the icon, not the <i>: FontAwesome may swap the
  // <i> for an <svg>, and Bootstrap 5 reads its text from data-bs-title, not the
  // Bootstrap 4 data-original-title this used to set (which is why it never showed).
  setWaitlistTooltip() {
    const trigger = this.waitlistToggleTarget.querySelector('[data-bs-toggle="tooltip"]')
    if (!trigger) return

    const length = this.chosenProgramQueueLength()
    if (length === undefined) {
      trigger.classList.add("d-none")
      return
    }

    const text = `Waitlist length for this category is set to ${length} by your association administrator.`
    trigger.setAttribute("data-bs-title", text)
    const tooltip = window.bootstrap.Tooltip.getOrCreateInstance(trigger)
    tooltip.setContent({ ".tooltip-inner": text })
    trigger.classList.remove("d-none")
  }

  chosenProgramCanHaveWaitlists() {
    return this.programChoiceTarget.options[this.programChoiceTarget.selectedIndex].dataset.waitlist === "true"
  }

  chosenProgramCanHaveSelfCheckIn() {
    return this.programChoiceTarget.options[this.programChoiceTarget.selectedIndex].dataset.selfCheckIn === "true"
  }

  chosenProgramQueueLength() {
    return this.programChoiceTarget.options[this.programChoiceTarget.selectedIndex].dataset.queue
  }

  reservationsRequiredIsChecked() {
    return this.resToggleTarget.checked
  }

  deselectWaitlistEnabled() {
    this.waitlistToggleTarget.querySelector("input#event_waitlist_enabled").checked = false
  }

  hideSelfCheckIn() {
    if (this.hasSelfCheckInToggleTarget) {
      this.selfCheckInToggleTarget.classList.add("d-none")
    }
  }

  showSelfCheckIn() {
    if (this.hasSelfCheckInToggleTarget) {
      this.selfCheckInToggleTarget.classList.remove("d-none")
    }
  }

  deselectSelfCheckIn() {
    if (this.hasSelfCheckInToggleTarget) {
      const checkbox = this.selfCheckInToggleTarget.querySelector("input#event_self_check_in_enabled")
      if (checkbox) {
        checkbox.checked = false
        const options = document.getElementById("self-check-in-options")
        if (options) options.style.display = "none"
      }
    }
  }
}
